export const getRemoteNavigationItems = (isLandscape) => [
  isLandscape ? ['schedule', 'Schedule'] : ['venue', 'Venue'],
  ['remote', 'Remote'],
  isLandscape ? ['epg', 'EPG'] : ['launcher', 'Launcher'],
];

export const getRemotePortraitPage = (page) => ({
  venue: 'venue',
  schedule: 'venue',
  remote: 'remote',
  launcher: 'launcher',
  settings: 'launcher',
  epg: 'launcher',
}[page] || 'venue');

export const getRemotePageForOrientation = (page, isLandscape) => {
  const portraitPage = getRemotePortraitPage(page);
  if (!isLandscape) return portraitPage;
  if (portraitPage === 'venue') return 'schedule';
  if (portraitPage === 'launcher') return 'epg';
  return portraitPage;
};

export const getRemotePageIndex = (page) => ({
  venue: 0,
  schedule: 0,
  remote: 1,
  launcher: 2,
  settings: 2,
  epg: 2,
}[page] ?? 0);

export const isRemoteLandscape = ({ deviceOrientation, orientationMatches, width, height, widthChanged = false, previousLandscape }) => {
  // CSS orientation describes the viewport, which can change when a keyboard opens.
  if (typeof deviceOrientation === 'string') {
    if (deviceOrientation.startsWith('landscape')) return true;
    if (deviceOrientation.startsWith('portrait')) return false;
  }
  if (typeof deviceOrientation === 'number') return Math.abs(deviceOrientation) === 90;
  // A height-only resize also happens as the keyboard closes after blur.
  if (!widthChanged && typeof previousLandscape === 'boolean') return previousLandscape;
  if (typeof orientationMatches === 'boolean') return orientationMatches;
  return width > height;
};

export const keepRemoteInputVisible = (input, viewport) => {
  const screen = input?.closest?.('.phone-remote__screen');
  if (!screen) return;
  const bounds = input.getBoundingClientRect();
  const screenBounds = screen.getBoundingClientRect();
  const visibleTop = Math.max(screenBounds.top, viewport?.offsetTop || 0) + 12;
  const visibleBottom = Math.min(screenBounds.bottom, (viewport?.offsetTop || 0) + (viewport?.height || window.innerHeight)) - 12;
  if (bounds.bottom > visibleBottom) screen.scrollTop += bounds.bottom - visibleBottom;
  else if (bounds.top < visibleTop) screen.scrollTop -= visibleTop - bounds.top;
};
